/* eslint-disable no-undef */
export const apiConfig = {
  backendUrl: process.env.REACT_APP_BASEAPI_URL,
  sentryDsn: "",
  googleAnalyticsId: undefined
};
// APi Services prefixes
export const identityPrefix = "/identity-api";
export const quotesPrefix = "/quotes-api";
